import { useState, useRef, useCallback } from "react";

const BEFORE_IMG = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/1e5svdll_Ultra-photorealistic%2C_8K_resolution_202603300900.png";
const AFTER_IMG = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/7ot8pf2z_Ultra-photorealistic%2C_12K_resolution._202603300937.png";

export default function InteractiveSlider() {
  const [sliderPos, setSliderPos] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const updatePosition = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPos(percentage);
  }, []);

  const handleStart = useCallback((e) => {
    isDragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePosition(clientX);
  }, [updatePosition]);

  const handleMove = useCallback((e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePosition(clientX);
  }, [updatePosition]);

  const handleEnd = useCallback(() => {
    isDragging.current = false;
  }, []);

  return (
    <section
      id="preview"
      data-testid="interactive-slider-section"
      className="py-24 md:py-32 lg:py-40 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-20">
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#00FF00] mb-4">
            // Previa interativa
          </p>
          <h2 className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white">
            A <span className="text-[#00FF00]">magia</span> da Advanse IA
          </h2>
          <p className="text-base md:text-lg text-white/50 mt-4 max-w-xl">
            Arraste para ver a transformacao. De uma foto simples a uma imagem de estudio profissional.
          </p>
        </div>

        {/* Slider */}
        <div
          ref={containerRef}
          data-testid="before-after-slider"
          className="slider-container relative w-full aspect-[4/3] md:aspect-[16/9] max-h-[600px] border border-white/10"
          onMouseDown={handleStart}
          onMouseMove={handleMove}
          onMouseUp={handleEnd}
          onMouseLeave={handleEnd}
          onTouchStart={handleStart}
          onTouchMove={handleMove}
          onTouchEnd={handleEnd}
        >
          {/* After image (full background) */}
          <img
            src={AFTER_IMG}
            alt="Depois - Imagem de estudio com IA"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Before image (clipped) */}
          <div
            className="slider-overlay absolute inset-0"
            style={{ width: `${sliderPos}%` }}
          >
            <img
              src={BEFORE_IMG}
              alt="Antes - Foto original"
              className="absolute inset-0 h-full object-cover"
              style={{ width: `${containerRef.current ? containerRef.current.offsetWidth : 1000}px` }}
            />
          </div>

          {/* Slider handle */}
          <div
            className="slider-handle"
            style={{ left: `${sliderPos}%` }}
          />

          {/* Labels */}
          <div className="absolute top-4 left-4 z-20 bg-black/70 px-3 py-1.5 border border-white/10">
            <span className="font-['JetBrains_Mono'] text-xs tracking-wider text-white/70">ANTES</span>
          </div>
          <div className="absolute top-4 right-4 z-20 bg-black/70 px-3 py-1.5 border border-[#00FF00]/30">
            <span className="font-['JetBrains_Mono'] text-xs tracking-wider text-[#00FF00]">DEPOIS</span>
          </div>
        </div>
      </div>
    </section>
  );
}
